import React from "react";
import {makeStyles, Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from "@material-ui/core";
import clsx from "clsx";
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import DemandPlanRealizationRow from "./DemandPlanRealizationRow";

const useStyles = makeStyles(theme => ({
    table: {
        tableLayout: 'fixed',

        '& td, th': {
            overflow: 'hidden',
        }
    },
    cell: {
        padding: theme.spacing(1)
    },
    lpColumn: theme.components.table.lpColumn,
    dateColumn: theme.components.table.dateColumn,
    cancelColumn: {
        width: 100,
        padding: '0 !important'
    },
    partName: {
        width: 310
    },
    valueColumn: {
        width: 350
    },
}));

function DemandPlanRealizationTable(
    {
        demandId,
        editable,
        demandPlanRealizations,
        formikProps,
        passiveOfferForm,
        exPost
    }) {

    const classes = useStyles();

    return (<TableContainer>
        <Table className={clsx(classes.table)}>
            <TableHead>
                <TableRow>
                    <TableCell className={clsx(classes.lpColumn, classes.cell)}>{Tr("column_lp")}</TableCell>
                    <TableCell className={clsx(classes.partName, classes.cell)}>{Tr("part_name")}</TableCell>
                    <TableCell className={classes.cell}>{Tr("plan_item_name_number")}</TableCell>
                    <TableCell className={clsx(classes.valueColumn, classes.cell)}>{Tr("plan_item_realization_value")}</TableCell>
                    {(!!passiveOfferForm || !!exPost) && <TableCell className={classes.cancelColumn}>{Tr("agreement_state_annuled")}</TableCell>}
                </TableRow>
            </TableHead>
            <TableBody>
                {demandPlanRealizations.map((realization, index) =>
                    <DemandPlanRealizationRow
                        key={realization.realizationId}
                        realization={realization}
                        index={index}
                        editable={editable}
                        demandId={demandId}
                        formikProps={formikProps}
                        passiveOfferForm={passiveOfferForm}
                        exPost={exPost}
                    />
                )}
            </TableBody>
        </Table>
    </TableContainer>)
}

DemandPlanRealizationTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    editable: PropTypes.bool.isRequired,
    passiveOfferForm: PropTypes.bool.isRequired,
    exPost: PropTypes.bool.isRequired,
    demandPlanRealizations: PropTypes.array.isRequired
}

export default DemandPlanRealizationTable;

